var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('b-container',{staticClass:"job-search",attrs:{"fluid":"sm"}},[_c('b-row',[_c('b-col',[_c('JobSearchFilters')],1),_c('b-col',{attrs:{"md":"9"}},[_c('JobSearchList')],1)],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }